import getFirebaseAuth from 'actions/firebase/auth'
import { signOut } from 'firebase/auth'

const logout = async () => signOut(getFirebaseAuth())

export default logout
